import { jsPDF } from 'jspdf'

export function downloadPDF (context, image, size) {
  // create the pdf and insert stuff
  /* eslint new-cap: 0 */
  const doc = new jsPDF()

  // title
  const challengeName = context.rootState.challenge.currentlyViewedChallenge.name
  addHeader(doc, `Basadur - ${challengeName}`, `${new Date().toDateString()}`)

  // canvas
  const left = 15
  const maxWidth = doc.internal.pageSize.getWidth() - left * 2
  const maxHeight = doc.internal.pageSize.getHeight() - 100
  const aspect = size.h / size.w
  if (aspect < maxHeight / maxWidth) { // maximizing the width would fit the whole image on the page
    doc.addImage(image, 'JPEG', left, 50, maxWidth, aspect * maxWidth)
  } else { // height would overflow if we maximize width
    const width = size.w / size.h * maxWidth
    const center = Math.floor(maxWidth / 2) - Math.floor(width / 2) + left
    doc.addImage(image, 'JPEG', center, 50, width, maxHeight)
  }
  addFooter(doc)

  // facts
  buildListPage(doc, 'Facts', context.state.facts.facts, (x) => x.content + ' - ' + new Date(x.created).toLocaleString())

  // public thoughts
  buildListPage(doc, 'Public Thoughts', context.state.thoughtCatcher.publicThoughts, (x) => x.content + ' - Pinned by: ' + x.pins.length + ' - ' + new Date(x.created).toLocaleString())

  // parking lot
  buildListPage(doc, 'HMWs', context.state.HMW.HMWs, (x) => x.content + ' - ' + new Date(x.created).toLocaleString())

  doc.save(`${challengeName}_${new Date().toLocaleDateString().replaceAll('/', '-')}.pdf`)
}

function buildListPage (doc, title, list, formattingFunc) {
  doc.addPage()
  addHeader(doc, title, null)
  doc.setFontSize(12)
  let offsetY = 45
  for (const item of list) {
    doc.text('• ' + formattingFunc(item), 15, offsetY)
    offsetY += 15
  }
  addFooter(doc)
}

function addHeader (doc, title, subTitle) {
  const tmp = doc.getFillColor()
  doc.setFillColor(255, 150, 25)
  doc.rect(0, 0, doc.internal.pageSize.width, 25, 'F')
  doc.addImage(doc.loadFile(require('@/assets/logo_v2_white.png')), 'PNG', 5, 4, 13, 15)
  doc.setFillColor(tmp)

  const textSize = doc.getFontSize()
  doc.setFontSize(24)
  doc.setTextColor(255, 255, 255)
  doc.text(title, 30, subTitle ? 10 : 16)
  if (subTitle) {
    doc.setFontSize(18)
    doc.setTextColor(230, 230, 230)
    doc.text(subTitle, 30, 20)
  }
  doc.setTextColor(10, 10, 10)
  doc.setFontSize(textSize)
}

function addFooter (doc) {
  const tmp = doc.getFillColor()
  const tmp2 = doc.getFontSize()
  doc.setFillColor(255, 150, 25)
  doc.rect(15, doc.internal.pageSize.height - 25, doc.internal.pageSize.width - 30, 1, 'F')
  doc.setFontSize(18)
  doc.setTextColor(100, 100, 100)
  doc.text('basadur.com', 15, doc.internal.pageSize.height - 15)
  doc.setFontSize(tmp2)
  doc.setFillColor(tmp)
}
